import ZJApis from "../api";
import utils from "../utils";

export default {
  data() {
    return {
      logInfo: {
        LogDate: null,
        UserName: "",
        UserNum: "",
        ActionName: "",
        LogMessage: "",
        ModuleName: "",
        PageName: "",
        LogId: "",
        LogTimeStamp: 0,
      },
    };
  },
  methods: {
    addOperationLog() {
      // this.logInfo.UserName = this.user.UserName;
      // this.logInfo.UserNum = this.user.UserId;
      // this.logInfo.LogDate = new Date().format("yyyy-MM-dd hh:mm:ss");
      // this.logInfo.LogId = utils.uuid();

      // new ZJApis.OperationLogApi().AddItem(this.logInfo);
    },
    addErrorLog() {
      this.logInfo.UserName = this.user.UserName;
      this.logInfo.UserNum = this.user.UserId;
      this.logInfo.LogDate = new Date().format("yyyy-MM-dd hh:mm:ss");
      this.logInfo.LogId = utils.uuid();
      this.logInfo.LogLevel = "Error";

      // new ZJApis.ErrorLogApi().AddItem(this.logInfo);
    },
  },
};
